import React, { createRef, forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { classNames } from 'primereact/utils';
import AppInlineMenu from './AppInlineMenu';
import { Ripple } from 'primereact/ripple';
import { Badge } from 'primereact/badge';

const AppSubmenu = forwardRef((props: any, ref: any) => {
    const [activeIndex, setActiveIndex] = useState<any>(null);
    const submenuRefs = useRef<{ [key: number]: HTMLUListElement | null } | any>();
    // const submenuRef = useRef<any>(null);
    const [menuStyle, setMenuStyle] = useState<any>({});

    const location = useLocation(); // ✅ Detects route changes

    // ✅ Close submenu when the route changes
    useEffect(() => {
        setActiveIndex(null);
    }, [location.pathname]); // Close submenu on navigation

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (!submenuRefs.current) submenuRefs.current = {};
            if (submenuRefs.current && !submenuRefs.current.contains(event.target as Node)) {
                setActiveIndex(null); // Close submenu
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const onMenuItemClick = (event: any, item: any, index: any) => {
        if (item.disabled) {
            event.preventDefault();
            return;
        }

        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
            event.preventDefault();
        }

        if (item.items) {
            event.preventDefault();
        }

        if (props.root) {
            props.onRootMenuItemClick({
                originalEvent: event
            });
        }

        // if (item.items) {
        //     setActiveIndex(index === activeIndex ? null : index);
        // } else {
        //     if (props.menuMode !== 'sidebar') {
        //         const ink = getInk(event.currentTarget);
        //         if (ink) {
        //             removeClass(ink, 'p-ink-active');
        //         }
        //     }
        // }
        // setActiveIndex(index === activeIndex ? null : index);
        if (item.items) {
            event.preventDefault();
            setActiveIndex(index === activeIndex ? null : index);
        } else {
            setActiveIndex(null); // Reset only if no subitems
        }

        props.onMenuItemClick({
            originalEvent: event,
            item: item
        });

        adjustMenuPosition();
    };

    const adjustMenuPosition = () => {
        if (submenuRefs.current) {
            const rect = submenuRefs?.current?.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            if (rect.bottom > viewportHeight) {
                setMenuStyle({ top: `-${rect.height}px` }); // Move menu up
            } else {
                setMenuStyle({ top: '100%' }); // Normal position
            }
        }
    };

    const onKeyDown = (event: any, item: any, index: any) => {
        if (event.key === 'Enter') {
            onMenuItemClick(event, item, index);
        }
    };

    const getInk = (el: any) => {
        for (let i = 0; i < el.children.length; i++) {
            if (typeof el.children[i].className === 'string' && el.children[i].className.indexOf('p-ink') !== -1) {
                return el.children[i];
            }
        }
        return null;
    };

    const removeClass = (element: any, className: string) => {
        if (element.classList) element.classList.remove(className);
        else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    };

    const onMenuItemMouseEnter = (index: any) => {
        if (props.root && props.menuActive && isHorizontalOrSlim() && !isMobile()) {
            setActiveIndex(index);
        }
    };

    const isMobile = () => {
        return window.innerWidth <= 991;
    };
    const isStatic = () => {
        return props.menuMode === 'static';
    };

    const isHorizontalOrSlim = useCallback(() => {
        return props.menuMode === 'horizontal' || props.menuMode === 'slim';
    }, [props.menuMode]);

    const visible = (item: any) => {
        return typeof item.visible === 'function' ? item.visible() : item.visible !== false;
    };

    const getLink = (item: any, index: any) => {
        const menuitemIconClassName = classNames('layout-menuitem-icon', item.icon);
        const content = (
            <>
                <i className={menuitemIconClassName}></i>
                <span className="layout-menuitem-text">{item.label}</span>
                {item.items && <i className="pi pi-fw pi-chevron-down  layout-submenu-toggler"></i>}
                {item.badge && <Badge value={item.badge} severity="success" />}

                <Ripple />
            </>
        );
        const commonLinkProps = {
            style: item.style,
            className: classNames(item.className, 'p-ripple', {
                'p-disabled': item.disabled
            }),
            target: item.target,
            onClick: (e: any) => onMenuItemClick(e, item, index),
            onMouseEnter: () => onMenuItemMouseEnter(index),
            onKeyDown: (e: any) => onKeyDown(e, item, index)
        };

        if (item.to) {
            return (
                <NavLink to={item.to} {...commonLinkProps} className={({ isActive }) => classNames(commonLinkProps.className, isActive ? 'active-route' : undefined)}>
                    {content}
                </NavLink>
            );
        } else {
            return (
                <a href={item.url} rel="noopener noreferrer" tabIndex={item.url ? undefined : 0} {...commonLinkProps}>
                    {content}
                </a>
            );
        }
    };

    // const getItems = () => {
    //     const transitionTimeout = isHorizontalOrSlim() && !props.root ? { enter: 1000, exit: 450 } : isHorizontalOrSlim() && !isMobile() ? 0 : { enter: 1000, exit: 450 };
    //     return props.items.map((item: any, i: any) => {
    //         if (visible(item)) {
    //             const submenuRef = createRef();
    //             const active = activeIndex === i;
    //             const menuitemClassName = classNames({
    //                 'layout-root-menuitem': props.root,
    //                 'active-menuitem': active && !item.disabled
    //             });
    //             const link = getLink(item, i);

    //             return (
    //                 <li key={item.label || i} className={menuitemClassName} role="menuitem">
    //                     {props.root && isStatic() && <div className="layout-menuitem-text">{item.label}</div>}
    //                     {link}
    //                     {item.items && (
    //                         <ul
    //                             ref={(el) => (submenuRefs.current[i] = el)}
    //                             className="submenu"
    //                             style={{
    //                                 position: 'absolute',
    //                                 left: '100%',
    //                                 top: '0', // Default to avoid flickering
    //                                 display: active ? 'block' : 'none'
    //                             }}
    //                         >
    //                             {item.items.map((subItem: any, subIndex: number) => (
    //                                 <li key={subIndex}>
    //                                     <a href={subItem.url || '#'}>{subItem.label}</a>
    //                                 </li>
    //                             ))}
    //                         </ul>
    //                     )}

    //                     <CSSTransition
    //                         // @ts-ignore
    //                         nodeRef={submenuRef}
    //                         classNames="p-toggleable-content"
    //                         timeout={transitionTimeout}
    //                         in={item.items && props.root && isStatic() ? true : active}
    //                         unmountOnExit
    //                     >
    //                         <AppSubmenu ref={submenuRef} items={visible(item) && item.items} menuActive={props.menuActive} menuMode={props.menuMode} parentMenuItemActive={active} onMenuItemClick={props.onMenuItemClick}></AppSubmenu>
    //                     </CSSTransition>
    //                 </li>
    //             );
    //         }

    //         return null;
    //     });
    // };

    const getItems = () => {
        return props.items.map((item: any, i: number) => {
            if (visible(item)) {
                const active = activeIndex === i;
                const menuitemClassName = classNames({
                    'layout-root-menuitem': props.root,
                    'active-menuitem': active && !item.disabled
                });

                return (
                    !window.cn(props?.items) &&
                    props?.items.length > 0 && (
                        <li key={item.label || i} className={menuitemClassName} role="menuitem">
                            {props.root && isStatic() && <div className="layout-menuitem-text">{item.label}</div>}
                            {getLink(item, i)}
                            {item.items && (
                                <ul
                                    ref={(el) => {
                                        if (!submenuRefs.current) submenuRefs.current = {}; // Ensure it is initialized
                                        submenuRefs.current[i] = el;
                                    }}
                                    className="submenu"
                                    style={{
                                        position: 'absolute',
                                        left: '100%',
                                        top: '0', // Default to avoid flickering
                                        display: active ? 'block' : 'none'
                                    }}
                                >
                                    {item.items.map((subItem: any, subIndex: number) => (
                                        <>
                                            <li key={subIndex}>
                                                <NavLink to={subItem.to}>{subItem.label}</NavLink>
                                            </li>
                                        </>
                                    ))}
                                </ul>
                            )}
                        </li>
                    )
                );
            }
            return null;
        });
    };

    // Dynamically adjust submenu position when activeIndex changes
    useEffect(() => {
        if (activeIndex !== null && submenuRefs.current[activeIndex]) {
            const parentItem = submenuRefs.current[activeIndex]?.parentElement;
            if (parentItem) {
                const parentRect = parentItem.getBoundingClientRect();
                const topOffset = parentRect.top + window.scrollY; // Calculate absolute top position
                submenuRefs.current[activeIndex]!.style.top = `${parentRect.bottom - 66}px`; // Set submenu position
            }
        }
    }, [activeIndex]);

    // useEffect(() => {
    //     if (props.resetActiveIndex && isHorizontalOrSlim()) {
    //         setActiveIndex(null);
    //     }
    // }, [props.resetActiveIndex, isHorizontalOrSlim]);

    // useEffect(() => {
    //     if (!props.menuActive && isHorizontalOrSlim() && !isMobile()) {
    //         setActiveIndex(null);
    //     }
    // }, [props.menuActive, isHorizontalOrSlim]);

    if (!props.items) {
        return null;
    }

    const items = getItems();
    return (
        <ul ref={submenuRefs} className={props.className} style={menuStyle} role="menu">
            {items}
        </ul>
    );
});

const AppMenu = (props: any) => {
    const navigate = useNavigate();

    const isOverlay = () => {
        return props.menuMode === 'overlay';
    };

    const isSidebar = () => {
        return props.menuMode === 'sidebar';
    };

    return (
        <div
            className={classNames('layout-menu-wrapper', {
                'layout-sidebar-active': props.sidebarActive
            })}
            onClick={props.onMenuClick}
            onMouseOver={props.onSidebarMouseOver}
            onMouseLeave={props.onSidebarMouseLeave}
        >
            <div className="menu-logo">
                {/* <button className="logo p-link">
                    <img src="/favicon.png" className="logo-img" onClick={() => navigate('/dashboard')} alt="logo" />
                </button> */}

                <button className="menu-pin p-link" onClick={props.onToggleMenu}>
                    {isOverlay() && <span className="pi pi-times"></span>}
                    {isSidebar() && !props.sidebarStatic && props.pinActive && <span className="pi pi-unlock"></span>}
                    {isSidebar() && props.sidebarStatic && props.pinActive && <span className="pi pi-lock"></span>}
                </button>
            </div>

            <div className="layout-menu-container">
                <AppSubmenu
                    items={props.model}
                    className="layout-menu "
                    menuMode={props.menuMode}
                    menuActive={props.menuActive}
                    root
                    parentMenuItemActive
                    onMenuClick={props.onMenuClick}
                    onMenuItemClick={props.onMenuItemClick}
                    onRootMenuItemClick={props.onRootMenuItemClick}
                />
            </div>

            <AppInlineMenu menuMode={props.menuMode} activeInlineProfile={props.activeInlineProfile} onChangeActiveInlineMenu={props.onChangeActiveInlineMenu} />
        </div>
    );
};

export default AppMenu;
